define('models/Cached',['models/Base'], function(Base) {

/*
invalidate old cache!
var def, cache = localStorage.getItem('PatientNames');
			if (cache !== null) {
				var data = JSON.parse(cache);
				if (data.accountid === Session.attr('AccountId') && Date.now() - data.timestamp < 1800000) { // 30 min
					def = can.Deferred().resolve(data.patients);
				}
			}
*/

	function makeFind(fn) {
		return function(findData) {
			var cachedRequests = {};
			return function (params, success, error) {
				var jsonParams = JSON.stringify(params);
				if (!cachedRequests[jsonParams]) {
					cachedRequests[jsonParams] = findData(params).then(can.proxy(fn, this));
				}
				var def = cachedRequests[jsonParams];
				def.then(success, error);
				return def;
			}
		}
	}
	
	return Base.extend({
	
		makeFindOne: makeFind(function (data) {
			return this.model(data)
		}),
		
		makeFindAll: makeFind(function (data) {
			return this.models(data)
		})

	},{});

});
